<template>
    <div class="flex">
        <UAvatar
            @click="onClick"
            :size="size || 'lg'" 
            :alt="placeholder" 
            :src="src" 
            :ui="{ rounded: rounded || 'rounded-lg' }"
            :class="{ 'cursor-pointer': modal && src }"
            :chip-color="chipColor"
        />

        <UModal v-if="modal" v-model="modalVisible" class="relative">
            <UAvatar 
                @click="modalVisible = false" 
                :src="src" 
                :ui="{ size: 'size-40', rounded: 'rounded-lg' }"
            />
        </UModal>
    </div>
</template>

<script setup lang="ts">
import type { AvatarSize } from '#ui/types'

const props = withDefaults(defineProps<{
    path?: string
    bucket?: string
    folder?: string
    size?: AvatarSize
    placeholder?: string
    rounded?: string
    modal?: boolean
    chipColor?: string
}>(), {
    bucket: 'avatars',
    folder: '',
})

const supabase = useSupabaseClient()

const src = ref()
const modalVisible = ref<boolean>(false)

onMounted(() => downloadImage())

watch(() => props.path, () => {
    if (props.path) {
        downloadImage()
    } else {
        src.value = undefined
    }
})

async function downloadImage() {
    if (props.path) {
        try {
            const objectPath = props.folder ? `${props.folder}/${props.path}` : props.path
            const { data, error } = await supabase.storage.from(props.bucket).download(objectPath)
            if (error) throw error
            src.value = URL.createObjectURL(data)
        } catch (error: any) {
            console.error('Error downloading avatar: ', error.message)
        }
    }
}

function onClick() {
    if (props.modal && src.value) {
        modalVisible.value = true
    }
}
</script>
